export const sort = (list, comparator = (item) => item) => {
  return list.sort((a, b) =>
    comparator(a).localeCompare(comparator(b), undefined, { numeric: true })
  );
};
